// src/components/lessons/renderers/WarningListRenderer.jsx
import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const WarningListRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
 const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div
      style={{
        background: '#FFFFFF',
        borderRadius: '0.75rem',
        padding: isMobile ? '1.25rem' : '1.5rem',
        border: '2px solid #000000',
        marginBottom: '1.5rem',
        boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Black accent bar at top */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: '#000000'
      }} />

      {block.title && (
        <h4 style={{
          fontWeight: '700',
          color: '#000000',
          marginBottom: '1.25rem',
          marginTop: '0.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          fontSize: isMobile ? '1rem' : '1.1rem'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: '#000000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#3A86FF',
            transition: 'transform 0.3s ease',
            transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
          }}>
            <AlertTriangle size={16} />
          </div>
          {block.title}
        </h4>
      )}

      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {block.items.map((item, i) => (
          <li
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '0.75rem',
              marginBottom: i === block.items.length - 1 ? 0 : '1rem',
              paddingBottom: i === block.items.length - 1 ? 0 : '1rem',
              borderBottom: i === block.items.length - 1 ? 'none' : '1px solid #E5E7EB',
              padding: '0.75rem',
              marginLeft: '-0.75rem',
              marginRight: '-0.75rem',
              borderRadius: '0.5rem',
              background: hoveredItem === i ? '#F9FAFB' : 'transparent',
              transition: 'all 0.2s ease',
              cursor: 'default'
            }}
            onMouseEnter={() => setHoveredItem(i)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              background: hoveredItem === i ? '#000000' : '#3A86FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              transition: 'all 0.3s ease',
              transform: hoveredItem === i ? 'scale(1.15) rotate(12deg)' : 'scale(1) rotate(0deg)'
            }}>
              <AlertTriangle style={{
                width: '14px',
                height: '14px',
                color: hoveredItem === i ? '#3A86FF' : '#FFFFFF',
                transition: 'color 0.3s ease'
              }} />
            </div>
            <span style={{
  color: '#000000',
  lineHeight: '1.7',
  fontSize: isMobile ? '0.95rem' : '1rem',
  opacity: hoveredItem === i ? 1 : 0.85,
  transition: 'opacity 0.2s ease',
  flex: 1
}}>
  {processText(item)}
</span>
            {hoveredItem === i && (
              <div style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: '#3A86FF',
                marginTop: '0.5rem',
                flexShrink: 0
              }} />
            )}
          </li>
        ))}
      </ul>

      {/* Decorative corner dot */}
      {isHovered && (
        <div style={{
          position: 'absolute',
          bottom: '12px',
          right: '12px',
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: '#3A86FF',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />
      )}
    </div>
  );
};

export default WarningListRenderer;